import request from 'services/request';

export async function DynamicMassiveUpload({ cancelToken, data }) {
  let uri = `/AccountStatement/Api/v1/Statements/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
